import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: ('admin' | 'office')[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  // Check localStorage directly for tokens (faster than waiting for Redux state)
  const adminToken = localStorage.getItem('admin-token');
  const officeToken = localStorage.getItem('office-token');
  
  const isAuthenticated = !!(adminToken || officeToken);
  const userType: 'admin' | 'office' | null = adminToken ? 'admin' : (officeToken ? 'office' : null);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If specific roles are required, check if user has the right role
  if (allowedRoles && allowedRoles.length > 0) {
    if (!userType || !allowedRoles.includes(userType)) {
      // Redirect to appropriate page based on user type
      if (userType === 'admin') {
        return <Navigate to="/admin" replace />;
      } else if (userType === 'office') {
        return <Navigate to="/dashboard" replace />;
      }
      return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
